import Vue from 'vue'
import Vuex from 'vuex'
// import {getAdminInfo} from '@/api/getData'

Vue.use(Vuex)

const state = {
	adminInfo: {
		avatar: 'default.jpg'
	},
	fullLoading:false,
	FontSize:"",
	isMobile:false,
	footerId:"",

}

const mutations = {
	saveAdminInfo(state, adminInfo){
		state.adminInfo = adminInfo;
	},
	fullLoadingFun(state,fullLoading){
		state.fullLoading = fullLoading;
	},
	footerIdFun(state,footerId){
		state.footerId = footerId;
	},
}

const actions = {
	async getAdminData({commit}){
		try{
			if (res.status == 1) {
				commit('saveAdminInfo', res.data);
			}else{
				throw new Error(res)
			}
		}catch(err){
		}
	}
}
export default new Vuex.Store({
	state,
	actions,
	mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js